(() => {
  console.log('CustomerHub Phone Prefix Script Loaded');
  // ISO-2 -> calling code (string sin "+")
  // Añade países según tus Markets (o te lo paso completo si quieres).
  const ISO_TO_DIAL = {
    ES: '34',
    PT: '351',
    FR: '33',
    IT: '39',
    DE: '49',
    GB: '44',
    IE: '353',
    NL: '31',
    BE: '32',
    LU: '352',
    CH: '41',
    AT: '43',
    SE: '46',
    NO: '47',
    DK: '45',
    FI: '358',
    PL: '48',
    CZ: '420',
    SK: '421',
    RO: '40',
    GR: '30',
    HU: '36',
    BG: '359',
    HR: '385',
    SI: '386',
    EE: '372',
    LV: '371',
    LT: '370',
    US: '1',
    CA: '1',
    MX: '52',
    AR: '54',
    CL: '56',
    CO: '57',
    PE: '51',
    AU: '61',
    NZ: '64',
    JP: '81',
    KR: '82',
    CN: '86',
    IN: '91',
    // fallback al final
  };

  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  function isRegisterRoute() {
    return location.pathname.includes('/a/customerhub') && location.hash === '#account:a:register';
  }

  function resolveDefaultDialCode(select) {
    const iso = String(window.__ivbCountryIso || 'ES').toUpperCase();
    const wanted = ISO_TO_DIAL[iso] || '34';

    // Asegura que exista en el select (por si el hub no incluye todos)
    if (select?.querySelector?.(`option[value="${wanted}"]`)) return wanted;

    // Fallback seguro si no existe
    return select?.querySelector?.('option[value="34"]') ? '34' : (select?.options?.[0]?.value || wanted);
  }

  function applyDialCode(hub) {
    const root = hub?.shadowRoot;
    if (!root) return false;

    const select = root.querySelector('select.chCountryCode');
    if (!select) return false;

    const code = resolveDefaultDialCode(select);

    if (select.value !== code) {
      select.value = code;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  }

  async function waitForHub(timeoutMs = 15000) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const hub = document.querySelector('accounts-hub');
      if (hub && hub.shadowRoot) return hub;
      await sleep(250);
    }
    return null;
  }

  let shadowObserver = null;
  let initialized = false;

  async function init() {
    if (initialized) return;
    initialized = true;

    if (!isRegisterRoute()) return;

    const hub = await waitForHub();
    if (!hub) return;

    applyDialCode(hub);

    // Observa re-render dentro del shadow DOM
    shadowObserver?.disconnect();
    shadowObserver = new MutationObserver(() => {
      if (isRegisterRoute()) applyDialCode(hub);
    });
    shadowObserver.observe(hub.shadowRoot, { childList: true, subtree: true });
  }

  function teardown() {
    shadowObserver?.disconnect();
    shadowObserver = null;
    initialized = false;
  }

  function routeHandler() {
    if (isRegisterRoute()) init();
    else teardown();
  }

  routeHandler();
  window.addEventListener('hashchange', routeHandler);
})();
